import * as React from 'react';
import classnames from 'classnames';
import { Button, Image } from '@grandvisionhq/common';
import { Heading } from '@grandvisionhq/elements';
import { parseHtml } from '@grandvisionhq/utils';
import '@grandvisionhq/state';
import '../../../../../../context/actions.js';
import '../../../../../../context/reducer.js';
import '../../../../../../types/product.js';
import '../../../../../../context/ProductContext.js';
import '../../../../../../context/CmsContext.js';
import { TryOnButton } from '../../../../../VTO/components/TryOnButton/TryOnButton.js';
import '../../../../../VTO/context/VtoProvider.js';
import '@swc/helpers';
import 'usehooks-ts';
import '@grandvisionhq/analytics';

const FindOutSize = ({ findOutSizeCTA , findOutSizeDescription , findOutSizeImage , findOutSizeSubtitle , findOutSizeTitle , showVTOButton , onVTOStart , pushBookAppointmentClickEvent , pushVTOClickEvent ,  })=>{
    if (!findOutSizeTitle || !findOutSizeCTA || !findOutSizeImage) {
        return null;
    }
    const description = findOutSizeDescription ? parseHtml(findOutSizeDescription.value) : null;
    return /*#__PURE__*/ React.createElement("div", {
        className: "find-out-size"
    }, /*#__PURE__*/ React.createElement("div", {
        className: "find-out-size__container"
    }, /*#__PURE__*/ React.createElement("div", null, /*#__PURE__*/ React.createElement(Heading, {
        variant: "smallest",
        className: "find-out-size__title"
    }, findOutSizeTitle), /*#__PURE__*/ React.createElement("div", {
        className: "find-out-size__subtitle"
    }, findOutSizeSubtitle), /*#__PURE__*/ React.createElement("div", {
        className: "find-out-size__description"
    }, description), showVTOButton ? /*#__PURE__*/ React.createElement(TryOnButton, {
        variant: "solid",
        onClick: ()=>{
            onVTOStart();
            pushVTOClickEvent();
        }
    }) : /*#__PURE__*/ React.createElement(Button, {
        key: findOutSizeCTA.link.label,
        icon: findOutSizeCTA.icon,
        className: classnames('find-out-size__button', findOutSizeCTA.link.style),
        href: findOutSizeCTA.link.url,
        caption: findOutSizeCTA.link.label,
        variant: "solid",
        onClick: ()=>pushBookAppointmentClickEvent()
    })), /*#__PURE__*/ React.createElement(Image, {
        alt: findOutSizeImage.description || '',
        className: "find-out-size__image",
        url: findOutSizeImage.url
    })));
};

export { FindOutSize as default };
//# sourceMappingURL=FindOutSize.js.map
